<template>
  <div ref="body" style="position: relative; padding-bottom: 70px;" @mouseenter="divMouseenter">
    <div v-if="zoneId" class="tools">
      <vs-button class="py-0 px-3" type="border" color="secondary" style="background-color: #fff;" @click="onClick({id: 0, name: 0})">
        <div class="flex items-center" style="margin-top: 4px">
          <feather-icon icon="ChevronLeftIcon" style="width: 18px;"/>
          전체보기
        </div>
      </vs-button>
    </div>

    <div
      ref="tooltip"
      style="position: absolute; z-index: 1000; padding: 5px 10px; background-color: #fff; border: solid 2px #000; font-size: 14px; pointer-events: none; display: none;"
    ></div>

    <img
      ref="mapImage"
      :src="require('@/assets/images/도면/도면_인천공장.png')"
      alt=""
      usemap="#map3"
      class="w-full opacity-50"
      @load="updateCoords"
    />
    <svg
      viewBox="0 0 3406 1282"
      style="position: absolute; top: 0; left: 0; pointer-events: none;"
    >
      <template v-for="origin in original">
        <!-- 기존 polygon은 그대로 유지 -->
        <polygon v-if="origin.shape === 'poly'" :id="origin.id" fill="rgba(0, 0, 255, 0.3)" stroke="blue" :points="origin.coords" stroke-width="8" style="display: none" :key="`polygon_${origin.id}`"/>

        <!-- 중점대상일 때 삼각형 마커 -->
        <template v-if="origin.center && origin.isCritical && origin.edge > 0">
          <!-- 삼각형 그림자 -->
          <polygon
            :id="`${origin.id}_shadow`"
            :points="`${origin.center.x + 3},${origin.center.y - 48 + 3} ${origin.center.x - 48 + 3},${origin.center.y + 48 + 3} ${origin.center.x + 48 + 3},${origin.center.y + 48 + 3}`"
            fill="rgba(0,0,0,0.3)"
            :key="`triangle_shadow_${origin.id}`"
          />

          <!-- 삼각형 배경 -->
          <polygon
            :id="`${origin.id}_triangle`"
            :points="`${origin.center.x},${origin.center.y - 48} ${origin.center.x - 48},${origin.center.y + 48} ${origin.center.x + 48},${origin.center.y + 48}`"
            fill="#FF6B6B"
            stroke="#FF4757"
            stroke-width="2"
            :key="`triangle_${origin.id}`"
          />

          <!-- 삼각형 내부 텍스트 -->
          <text
            :id="`${origin.id}_text`"
            :x="origin.center.x"
            :y="origin.center.y + 12"
            fill="#fff"
            font-size="48px"
            text-anchor="middle"
            font-weight="600"
            alignment-baseline="middle"
            :key="`triangle_text_${origin.id}`"
          >
            {{ origin.edge }}
          </text>
        </template>

        <!-- 일반일 때 원형 마커 -->
        <template v-else-if="origin.center">
          <!-- 마커 배경 - 그림자 추가 -->
          <circle
            :id="`${origin.id}_shadow`"
            :cx="origin.center.x + 3"
            :cy="origin.center.y + 3"
            :r="origin.edge > 0 ? 54 : 32"
            fill="rgba(0,0,0,0.3)"
            :key="`shadow_${origin.id}`"
          />

          <!-- 마커 배경 -->
          <circle
            :id="`${origin.id}_circle`"
            :cx="origin.center.x"
            :cy="origin.center.y"
            :r="origin.edge > 0 ? 54 : 32"
            :fill="origin.edge > 0 ? 'rgba(220, 53, 69, 0.9)' : 'rgba(255, 255, 255, 0.9)'"
            :stroke="origin.edge > 0 ? '#c82333' : '#dee2e6'"
            stroke-width="2"
            :key="`circle_${origin.id}`"
          />

          <!-- 마커 내부 텍스트 -->
          <text
            :id="`${origin.id}_text`"
            :x="origin.center.x"
            :y="origin.center.y"
            :fill="origin.edge > 0 ? '#fff' : '#495057'"
            :font-size="origin.edge > 0 ? '48px' : '28px'"
            text-anchor="middle"
            font-weight="600"
            alignment-baseline="middle"
            :key="`text_${origin.id}`"
          >
            {{ origin.edge }}
          </text>
        </template>
      </template>

      <!-- 선택된 마커 스타일도 동일하게 수정 -->
      <template v-if="selectZone && selectZone.center">
        <polygon v-if="selectZone" id="currentZone" fill="rgba(0, 0, 255, 0.3)" stroke="blue" :points="selectZone.coords" stroke-width="8"/>

        <!-- 선택된 마커 그림자 -->
        <circle
          id="currentZone_shadow"
          :cx="selectZone.center.x + 3"
          :cy="selectZone.center.y + 3"
          r="28"
          fill="rgba(0,0,0,0.3)"
        />

        <!-- 선택된 마커 배경 -->
        <circle
          id="currentZone_circle"
          :cx="selectZone.center.x"
          :cy="selectZone.center.y"
          r="28"
          fill="rgba(220, 53, 69, 0.9)"
          stroke="#c82333"
          stroke-width="2"
        />

        <!-- 선택된 마커 텍스트 -->
        <text
          id="currentZone_text"
          :x="selectZone.center.x"
          :y="selectZone.center.y"
          fill="#fff"
          font-size="24px"
          text-anchor="middle"
          font-weight="600"
          alignment-baseline="middle"
        >
          {{ selectZone.edge }}
        </text>
      </template>
    </svg>

    <map name="map3">
      <area
        v-for="(s, index) in scaled"
        :key="index"
        :shape="s.shape"
        :coords="s.coords"
        href="#"
        @mouseover="showPolygon(s)"
        @mouseout="hidePolygon(s)"
        @click="onClick(s)"
      />
    </map>

    <!-- 범례 -->
    <div class="tools" style="top:auto; bottom: 10px; left: 50%; transform: translateX(-50%)">
      <div class="grid" style="grid-template-columns: auto auto; border: 1px solid #999999;">
        <span class="px-1" style="width: 8px; background-color: #999999; color:#fff;"></span>
        <div class="flex gap-4 p-2 font-bold">
          <div class="flex items-center gap-1">
            <div class="grid place-items-center rounded-full" style="width:32px; height: 32px; background-color: rgba(220, 53, 69, 0.9); color: #fff; font-size: 16px; font-weight: 600;"></div>
            일반작업
          </div>
          <div class="flex items-center gap-1">
            <div class="rounded-none"
                 style="width:32px; height:32px; padding-top: 6px;
              background-color: #FF4757;
              color:#fff; font-size:16px; font-weight:600;
              display:flex; align-items:center; justify-content:center;
              clip-path: polygon(50% 0%, 0% 100%, 100% 100%);"></div>
            중점대상현황
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapFactoryAccess2",
  props: {
    value: [String, Number],
    markers: Array,
  },
  data () {
    return {
      zoneId: this.value,
      selectZone: null,
      width: 3406,
      height: 1282,
      original: [
        { id: "74", label: "본관", edge: "0", shape: "poly", coords: "77,517,250,517,250,597,77,597" },
        { id: "75", label: "ESS", edge: "0", shape: "poly", coords: "321, 538, 437, 538, 437, 584, 321, 584" },
        { id: "76", label: "제품창고(1)", edge: "0", shape: "poly", coords: "500,521,767,521,767,600,500,600" },
        { id: "77", label: "제품창고(2)", edge: "0", shape: "poly", coords: "506,121,767,121,767,171,506,171" },
        { id: "78", label: "협력동(품질관리실)", edge: "0", shape: "poly", coords: "505,174,766,174,766,267,505,267" },
        { id: "79", label: "복지관", edge: "0", shape: "poly", coords: "878,85,1078,85,1078,165,878,165" },
        { id: "80", label: "1호 압연", edge: "0", shape: "poly", coords: "781,521,1624,521,1624,600,781,600" },
        { id: "81", label: "154kV", edge: "0", shape: "poly", coords: "1426,623,1488,623,1488,779,1426,779" },
        { id: "82", label: "생산2동", edge: "0", shape: "poly", coords: "1425,794,1489,794,1489,903,1425,903" },
        { id: "83", label: "1호 수처리", edge: "0", shape: "poly", coords: "1506, 642, 1588, 641, 1589, 779, 1503, 779" },
        { id: "84", label: "산소공장", edge: "0", shape: "poly", coords: "1603,781,1602,642,1703,641,1704,833,1650,833,1651,900,1531,900,1531,834,1505,834,1506,779" },
        { id: "85", label: "120T", edge: "0", shape: "poly", coords: "1728,529,1728,719,1732,720,1851,722,1852,675,1906,675,1906,745,1974,746,1974,528" },
        { id: "86", label: "120T 수처리", edge: "0", shape: "poly", coords: "2015, 534, 2073, 534, 2074, 707, 2014, 707" },
        { id: "87", label: "120T 집진기", edge: "0", shape: "poly", coords: "2099, 537, 2102, 709, 2161, 709, 2160, 537" },
        { id: "88", label: "120T SCRAP", edge: "0", shape: "poly", coords: "1742,747,2068,747,2068,853,1742,853" },
        { id: "89", label: "생산동", edge: "0", shape: "poly", coords: "1964,880,2076,880,2076,943,1964,943" },
        { id: "90", label: "2호 압연", edge: "0", shape: "poly", coords: "1462,943,2112,943,2112,1045,1462,1045" },
        { id: "91", label: "100T", edge: "0", shape: "poly", coords: "2174,865,2112,864,2114,1083,2351,1081,2349,852,2173,852" },
        { id: "92", label: "100T 수처리", edge: "0", shape: "poly", coords: "1460,1045,1796,1045,1796,1118,1460,1118" },
        { id: "93", label: "100T 집진기", edge: "0", shape: "poly", coords: "2431, 958, 2569, 955, 2486, 843, 2439, 844, 2413, 916, 2412, 939, 2421, 955" },
        { id: "94", label: "100T SCRAP", edge: "0", shape: "poly", coords: "2111,747,2399,747,2399,853,2111,853" },
        { id: "95", label: "슬라그 설비장", edge: "0", shape: "poly", coords: "2172,559,2174,719,2382,717,2384,698,2305,616" },
        { id: "96", label: "슬라그 덤핑장", edge: "0", shape: "poly", coords: "2429,963,2628,963,2628,1091,2429,1091" },
        { id: "97", label: "배후부지", edge: "0", shape: "poly", coords: "2434,624,2864,927,3012,722,2462,583" },
        { id: "98", label: "북항부두", edge: "0", shape: "poly", coords: "2946,1167,3126,1271,3388,815,3179,763" },
        { id: "118", label: "폐수처리", edge: "0", shape: "poly", coords: "2979,888,3024,915,3088,803,3040,779" },
      ],
      scaled: [],
    }
  },
  computed: {
    imgWidth() {
      return this.$refs.mapImage ? this.$refs.mapImage.clientWidth : 0;
    },
  },
  watch: {
    imgWidth: {
      handler() {
        this.updateCoords();
      },
      immediate: true,
    },
    markers(markers) {
      this.original.forEach((origin, i) => {
        markers.forEach((marker) => {
          if (`${origin.id}` === `${marker.id}`) {
            this.original[i].edge = marker.edge;
            this.original[i].isCritical = marker.isCritical; // 중점대상 여부 추가
          }
        });
      });
    },
  },
  mounted() {
    this.updateCoords();
    window.addEventListener("resize", this.updateCoords); // 창 크기 변경 시 좌표 갱신
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateCoords); // 이벤트 제거
  },
  methods: {
    updateCoords() {
      const img = this.$refs.mapImage;
      if (img) {
        const scaleX = img.clientWidth / this.width; // 원본 너비에 대한 스케일
        const scaleY = img.clientHeight / this.height; // 원본 높이에 대한 스케일

        // 도형의 중심을 계산하여 원 추가
        for (let i = 0; i<this.original.length; i++) {
          const coords = this.original[i];
          let center = {};
          if (coords.shape === "poly") {
            center = this.calculatePolygonCenter(coords.coords);
          } else if (coords.shape === "rect") {
            center = this.calculateRectCenter(coords.coords);
          }

          this.original[i].center = {
            x: center.x,
            y: center.y
          };
        }


        // 원본 좌표를 스케일에 맞게 변환
        this.scaled = this.original.map((coords) => {
          const coordsData = {
            id: coords.id,
            label: coords.label,
            shape: coords.shape,
            coords: coords.coords
              .split(",")
              .map((value, index) => {
                const scale = index % 2 === 0 ? scaleX : scaleY; // X 좌표와 Y 좌표에 따라 다른 스케일 적용
                return Math.round(value * scale); // 스케일링 후 반올림
              })
              .join(",")
          }
          return coordsData;
        });

      }
    },
    // 다각형의 중심을 계산하는 함수
    calculatePolygonCenter(coords) {
      const points = coords.split(",").map(Number);
      let x = 0, y = 0;
      const numPoints = points.length / 2;

      for (let i = 0; i < numPoints; i++) {
        x += points[i * 2];
        y += points[i * 2 + 1];
      }

      return {
        x: x / numPoints,
        y: y / numPoints
      };
    },

    // 사각형의 중심을 계산하는 함수
    calculateRectCenter(coords) {
      const [x1, y1, x2, y2] = coords.split(",").map(Number);
      return {
        x: (x1 + x2) / 2,
        y: (y1 + y2) / 2
      };
    },

    // 다각형 표시
    showPolygon(ss) {
      const id = ss.id
      const el = document.getElementById(id)
      if (el) {
        document.getElementById(id).style.display = 'block';
        const rectPosition = el.getBoundingClientRect();
        const parentPosition = this.$refs.body.getBoundingClientRect();
        this.$refs.tooltip.style.display = '';
        this.$refs.tooltip.style.top = `${rectPosition.top - parentPosition.top - 40}px`;
        this.$refs.tooltip.style.left = `${rectPosition.left - parentPosition.left}px`;
        this.$refs.tooltip.textContent = ss.label;
      }
    },
    hidePolygon(ss) {
      const id = ss.id
      if (document.getElementById(id)) {
        document.getElementById(id).style.display = 'none';
      }
      this.$refs.tooltip.style.display = 'none';
    },

    onClick (ss) {
      this.zoneId = ss.id;
      const find = this.original.find((item) => item.id === ss.id);
      if (find) {
        this.selectZone = find;
      } else {
        this.selectZone = null;
      }
      this.$emit("click", {id: ss.id, name: ss.label})
    },

    resetSelectZone() {
      this.selectZone = null;
    },

    divMouseenter() {
      this.updateCoords();
    },
  },
}
</script>

<style scoped>
circle.active {
  r: 54;
  fill: red;
  stroke: red;
  stroke-width: 4;
}
text.active {
  fill: #fff;
  font-size: 48px;
  font-weight: bold;
}
.tools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  background-color: #fff;
  border-radius: 6px;
}
</style>
